import React from 'react';
import styled from 'styled-components';
import axios from '../../axios';

//#region Styled Components
const StyledResult = styled.div`
  width: 400px;
  height: 400px;
  margin: 1rem;
  outline: none;
  border: 1px solid #d6d6d6;
  transition: border-color 0.15s ease;
  position: relative;
  z-index: 1;

  &:hover,
  &:focus,
  &:active {
    border-color: #5421cc;
    box-shadow: var(--box-shadow);
  }
`;

const StyledLink = styled.a`
  outline: none;
`;

const ImgContainer = styled.div`
  height: 300px;
  width: 300px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 0 auto;
`;

const ResultTitle = styled.div`
  margin-top: 1rem;
  padding: 0 0.5rem;
`;

const ResultPrice = styled.span`
  font-weight: bold;
`;

const AddResult = styled.div`
  height: 2.25rem;
  padding: 0.5rem;
  background-color: var(--button-main);
  color: white;
  font-size: 1.25em;
  display: flex;
  flex: row nowrap;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
`;
//#endregion

const Result = ({
  id,
  imgUrl,
  mode,
  postUrl,
  price,
  removeResult,
  selectedListId,
  tab,
  title,
}) => {
  // handles adding a result to a list
  const addResult = async () => {
    // must have a list selected!
    if (selectedListId === 'no-list-selected') {
      window.alert('Please Select A List!');
      return;
    }
    // build the request data
    const resultData = {
      [id]: {
        title: title,
        imgUrl: imgUrl,
        postUrl: postUrl,
        price: price,
      },
    };

    try {
      await axios.patch(`/lists/${selectedListId}/results.json`, resultData);
    } catch (error) {
      throw error;
    }
  };

  return (
    <StyledResult tabIndex={tab}>
      <StyledLink href={postUrl} target="_blank" rel="noopener noreferrer">
        <ImgContainer>
          <img alt="Item" src={imgUrl} />
        </ImgContainer>
        <ResultTitle>
          <span>{title}</span> - <ResultPrice>{price}</ResultPrice>
        </ResultTitle>
      </StyledLink>
      <AddResult onClick={mode === 'add' ? addResult : () => removeResult(id)}>
        {mode === 'add' ? 'Add to' : 'Remove from'} List
      </AddResult>
    </StyledResult>
  );
};

export default Result;
